import { Navigate } from "react-router";

import { resolveWorkspaceEntry } from "../app/workspace-entry";
import { AccessDeniedScreen } from "../auth/AccessDeniedScreen";
import { useSession } from "../auth/session";
import { SessionPendingScreen } from "../auth/SessionPendingScreen";

/**
 * The workspace entry point at `/`.
 *
 * It sends each role to the first screen that role actually works in, and
 * anyone signed out to sign-in. For a till-only role, or an account with no
 * shop, it explains the situation rather than redirecting anywhere.
 *
 * The decision itself lives in `resolveWorkspaceEntry` so that the shell names
 * this screen from the same answer this screen renders.
 */
export function WorkspaceEntryScreen() {
  const { session } = useSession();
  const entry = resolveWorkspaceEntry(session);

  switch (entry.kind) {
    case "pending":
      return <SessionPendingScreen />;
    case "denied":
      return <AccessDeniedScreen reason={entry.reason} />;
    case "redirect":
      return <Navigate replace to={entry.path} />;
  }
}
